import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';

export const deleteTimelineSection = async (
    { orgId, dealId, sectionId }: { orgId: string; dealId: number; sectionId: number },
) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.TIMELINE_SECTION_BY_ID(orgId, dealId, sectionId));
    return response.data;
};

export const useDeleteTimelineSection = () => useMutation({
    mutationFn: deleteTimelineSection,
});
